import React from 'react';

interface INicheMedicalSvgProps {
  width?: number;
  height?: number;
}

export const NicheMedicalSvg: React.FC<INicheMedicalSvgProps> = ({
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="16" y="9" width="8" height="22" rx="2" fill="#4CAF50" />
      <rect x="9" y="16" width="22" height="8" rx="2" fill="#4CAF50" />
    </svg>
  );
};
